import { Alert, AlertTitle } from "@mui/material";
import LockClockIcon from "@mui/icons-material/LockClock";

const BloqueadoBanner = () => {
  return (
    <Alert
      severity="warning"
      icon={<LockClockIcon fontSize="inherit" />}
      sx={{ borderRadius: 3, mb: 2, fontWeight: 500 }}
    >
      <AlertTitle sx={{ fontWeight: 700 }}>Elección de viandas cerrada</AlertTitle>
      Por ahora no se pueden crear, modificar ni cancelar pedidos. RRHH tiene que cargar el
      menú de la semana para reabrir la elección.
    </Alert>
  );
};

export default BloqueadoBanner;
